// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".control-row{margin-bottom:10px}.dropdown-menu{max-height:350px;overflow-y:auto}.settings-section{border-radius:5%;border:2px solid #28a745}", ""]);
// Exports
module.exports = exports;
